package co.maytes.standupbot.dashboard.features.setup

import co.maytes.standupbot.dashboard.lib.api.ApiError
import co.maytes.standupbot.shared.dto.setup.SetupCheckReportDto

data class SetupCheckState(
    val report: SetupCheckReportDto? = null,
    val running: Boolean = false,
    val error: String? = null,
) {
    val canStart: Boolean get() = !running

    fun started(): SetupCheckState = copy(running = true, error = null)

    fun finished(next: SetupCheckReportDto): SetupCheckState = copy(report = next, running = false, error = null)

    fun failed(message: String): SetupCheckState = copy(running = false, error = message)
}

object SetupCheckErrors {
    private const val TOO_MANY_REQUESTS = 429
    private const val FORBIDDEN = 403

    fun message(error: ApiError): String =
        when {
            error is ApiError.Http && error.status == TOO_MANY_REQUESTS ->
                "You've run the check a few times already. Wait a minute and try again."
            error is ApiError.Http && error.status == FORBIDDEN -> "Only admins can run the setup check."
            else -> error.displayMessage
        }
}
